import { useAuth, useUser } from "@tellescope/tanstack-query";
import { Button, cn } from "@tellescope/ui";
import { formatName } from "@tellescope/utils";
import { useState } from "react";
import { AvatarWithPicture } from "@tellescope/contacts";
import { ChevronsUpDown } from "lucide-react";
import { AccountDialog } from "./AccountDialog";

export interface SidebarAccountButtonProps {
  userId?: string;
}

export const SidebarAccountButton = ({ userId: providedUserId }: SidebarAccountButtonProps) => {
  const { currentUser } = useAuth();
  const userId = providedUserId || currentUser.id;
  const [open, setOpen] = useState(false);
  const user = useUser(userId ?? "");

  const userName = user ? formatName(user) : undefined;

  return (
    <>
      <Button
        variant="ghost"
        className={cn("flex items-center p-2 rounded-md w-full hover:bg-sidebar-accent", "justify-start gap-2")}
        onClick={() => {
          setOpen(true);
        }}
        title={userName}
      >
        <div className="flex items-start">{<AvatarWithPicture avatarLike={user ?? {}} className="h-8 w-8" />}</div>
        <div
          // TODO: [bb] add exit animation instead of opacity when we add motion
          className={cn("flex flex-1 justify-between overflow-hidden transition-opacity", "w-auto")}
        >
          <div className="flex flex-col justify-center items-start gap-0.5 flex-1">
            {!!userName && <p className="text-sm font-semibold text-sidebar-foreground leading-none">{userName}</p>}
            {!!currentUser.email && <p className="text-xs text-sidebar-foreground leading-none">{currentUser.email}</p>}
          </div>
          <div className="flex items-center justify-center">
            <ChevronsUpDown className="h-4 w-4 text-sidebar-foreground" />
          </div>
        </div>
      </Button>
      <AccountDialog userId={userId} open={open} setOpen={setOpen} />
    </>
  );
};
